import styled from "styled-components";
import {
  SearchOutlined,
  DownloadOutlined,
  MessageOutlined,
  LOGO_HOME,
} from "@assets";

export const Bar = styled.div`
  height: 70px;
  padding-inline: 15px 16px;
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  background: ${props => props.theme.appbarColor};
  box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px -1px,
    rgba(0, 0, 0, 0.14) 0px 4px 5px 0px, rgba(0, 0, 0, 0.12) 0px 1px 10px 0px;
  z-index: 1000;
`;

export const LogoWrapper = styled.div`
height: 70px;
flex: 1;
display: flex;
align-items: center;
justify-content: flex-start;
`;

export const Logo = styled(LOGO_HOME)`
margin-left: -35px;
`;

export const LogoText = styled.div`
margin-left: -23px;
font-size: 14px;
font-weight: 700;
color: #F7F7F7;
`;

export const IconsWrapper = styled.div`
display: flex;
gap: 12px;
align-items: center;
justify-content: center;

svg {
  cursor: pointer;
}

@media screen and (max-width: 375px){
  gap: 8px;
}
`;

export const SearchIcon = styled(SearchOutlined)``;
export const MessageIcon = styled(MessageOutlined)``;
export const DownloadIcon = styled(DownloadOutlined)``;